import React from 'react';
import EditorContainer from './EditorContainer ';

const BillHeaderFooterEditor = () => {
    return (
        <div>
            header footer editor 
            <EditorContainer />

        </div>
    );
};

export default BillHeaderFooterEditor;